import type { FormRule } from 'antd';

const MAX_INT_32 = 2147483647;
const MIN_INT_32 = -2147483648;

export const isSafeIntValidator = (fieldName: string): FormRule[] => [
  { type: 'integer', max: MAX_INT_32, message: `${fieldName} must be less than or equal to ${MAX_INT_32}` },
  { type: 'integer', min: MIN_INT_32, message: `${fieldName} must be greater than or equal to ${MIN_INT_32}` },
];
